var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-bar-container"},[_c('span',{staticClass:"pointer",style:(_vm.leftStyle)},[_vm._v(_vm._s(_vm.score))]),_c('span'),_c('p',_vm._l((_vm.scaleArr),function(item){return _c('span',{key:item},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }